import { useState } from "react";

import {
  EmojiPickerContent,
  EmojiPickerFooter,
  EmojiPickerRoot,
  EmojiPickerSearch,
} from "common/components/EmojiSelector/EmojiPicker";
import { Button, type ButtonProps } from "common/components/ui/Button";
import { DialogBody } from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "common/components/ui/Popover";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export interface EmojiSelectorProps {
  onEmojiSelection: (selectedEmoji: string) => void;
  buttonProps: ButtonProps;
}

export default function EmojiSelector({
  onEmojiSelection,
  buttonProps,
}: EmojiSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const isDesktop = useTwBreakpoint("lg");

  const Component = isDesktop ? Popover : Drawer;
  const Trigger = isDesktop ? PopoverTrigger : DrawerTrigger;
  const Content = isDesktop ? PopoverContent : DrawerContent;
  const Body = isDesktop ? DialogBody : DrawerBody;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Trigger asChild>
        <Button
          variant="ghost-black"
          intent="iconOnly"
          className="data-[state=open]:bg-black-100"
          {...buttonProps}
        />
      </Trigger>

      <Content>
        <Body>
          <EmojiPickerRoot
            columns={isDesktop ? 6 : 10}
            onEmojiSelect={({ emoji }) => {
              setIsOpen(false);
              onEmojiSelection(emoji);
            }}
          >
            <EmojiPickerSearch />
            <EmojiPickerContent />
            <EmojiPickerFooter />
          </EmojiPickerRoot>
        </Body>
      </Content>
    </Component>
  );
}
